import React, { useState } from 'react';
import {
  ExpandToggle,
  ExpandArrow,
  ExpandArrowIcon,
  SubGroup,
  SubItem,
  SubDot,
} from '../styled/SidePanel.styled';

const ExpandableGroup = ({ label, children: items }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div>
      <ExpandToggle onClick={() => setIsExpanded(!isExpanded)}>
        {label}
        <ExpandArrow isExpanded={isExpanded}>
          <ExpandArrowIcon viewBox="0 0 24 24">
            <polyline points="6 9 12 15 18 9" />
          </ExpandArrowIcon>
        </ExpandArrow>
      </ExpandToggle>
      <SubGroup isExpanded={isExpanded}>
        {items.map((item) => (
          <SubItem key={item.link} exact to={item.link}>
            <SubDot />
            {item.label}
          </SubItem>
        ))}
      </SubGroup>
    </div>
  );
};

export default ExpandableGroup;
